<template>
    <div class="form__group">
        <label for="event" class="form__label">Event</label>
        <multiselect
            name="event"
            :options="results"
            :placeholder="placeholder"
            :allow-empty="allowEmpty"
            label="eventName"
            track-by="id"
            :loading="loading"
            v-model="selected"
            v-validate="'required'"
            @input="updateValue"
            :class="{ 'form__control': true, 'form__control--invalid': errors.first(this.name) }">
            >
            <span slot="noOptions">Type a name to search users...</span>
        </multiselect>
        <div class="form__validation">{{ errors.first('event') }}</div>
    </div>
</template>

<script>
    import AjaxSelect from '../../Form/Control/AjaxSelect';
    import API from '@api';

    export default {
        name: 'EventDropdown',
        mixins: [AjaxSelect],
        props: {
            value: {
                type: String|Number,
                default: ''
            },
            events: {
                type: Array,
                default: () => []
            }
        },
        watch: {
            // value: function (newVal, oldVal) {
            //     console.log("Value changed", newVal, oldVal);
            //     if (newVal !== oldVal) {
            //         this.selected = newVal;
            //     }
            // }
        },
        created() {
            this.search('');
        },
        methods: {
            search(query) {
                API.getEvents({
                    query
                }).then(response => {
                    this.results = response;
                    // find the event in the list and set it
                    this.results.find(event => {
                        if (event.id === this.value) {
                            this.selected = event;
                        }
                    });
                }).finally(() => this.loading = false);
            },
            updateValue(event) {
                console.log("Got value", event);
                this.$emit('change', event);
            },
            eventName(event) {
                return event.eventName;
            },
        }
    }
</script>

<style scoped lang="scss">

</style>
